import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { IDTypeSelectorComponent  } from './id-type-selector.component';
import { ReactiveFormsModule } from '@angular/forms';
import { MatOptionModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { TranslateModule } from '@ngx-translate/core';

const components = [IDTypeSelectorComponent];
const modules = [
    TranslateModule,
    MatSelectModule,
    MatOptionModule,
    ReactiveFormsModule,
];

@NgModule({
    declarations: [...components],
    imports: [CommonModule, ...modules],
    exports: [...components],
})
export class IDTypeSelectorModule { }
